import ProjectCategoryTable from "@/app/app-shared/project-category/table";

export default function ProjectCategoryListingPage() {
  return (
    <div className="mt-4">
      <ProjectCategoryTable />
    </div>
  );
}
